module.exports = __webpack_public_path__ + "img/pc-download.23afcf30.webp";